<template>
  <div class="header container bg-white mx-auto p-0" :id="currentRouteId">
    <div class="bg-white">
      <div class="container mx-auto pt-6 pb-4 sticky-padding-small">
        <div class="flex items-center justify-between h-16">
          <div class="sm:mr-6 flex lg:hidden cart-hidden">
            <!-- Mobile menu button -->
            <button
              @click="toggleMobile"
              class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 focus:outline-none"
            >
              <svg
                :class="[isOpenMobile ? 'hidden' : 'block', 'h-6 w-6']"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h16M4 18h16"
                ></path>
              </svg>
              <svg
                :class="[isOpenMobile ? 'block' : 'hidden', 'h-6 w-6']"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
          <div class="flex items-center flex-grow">
            <div class="">
              <ClientOnly>
                <NuxtLink :to="homeUrl">
                    <img
                      class="logo"
                      :src="logo"
                      alt="Spring Green Logo"
                      loading="lazy"
                    />
                </NuxtLink>
              </ClientOnly>
            </div>
            <nav class="hidden lg:block flex-grow menu cart-hidden" :class="{ 'dropdowns-hidden': dropdownsHidden }">
              <ul class="ml-10 flex items-baseline justify-center">
                <li
                  v-for="menu in menus"
                  :key="menu.id"
                  :class="menu.slug.replaceAll('/', '-').slice(1)"
                  @mouseenter="dropdownsHidden = false"
                >
                  <div @click="hideMenu()">
                    <NuxtLink
                      :to="menu.slug"
                      class="menu-link px-3 py-2 md:mx-1 rounded-md text-sm font-medium text-gray-900 bg-white"
                    >
                      {{ menu.name }}
                    </NuxtLink>
                  </div>
                  <Dropdown
                    :menu="menu"
                    v-if="menu.primary && menu.primary.length > 0"
                    @hideDropdown="hideMenu()"
                  />
                </li>
              </ul>
            </nav>
          </div>
          <div class="menu-secondary cart-hidden">
            <div class="sm:ml-4 flex items-baseline md:ml-6">
              <a href="#" @click="toggleSearch" class="menu-secondary-link search-link">
                <div v-if="openSearch">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="flex mx-auto"
                  >
                    <rect
                      x="0.5"
                      y="2.9541"
                      width="2.76375"
                      height="40.535"
                      rx="1.38187"
                      transform="rotate(-45 0.5 2.9541)"
                      fill="#587C91"
                      stroke="#587C91"
                      stroke-width="0.5"
                    />
                    <rect
                      width="2.76375"
                      height="40.535"
                      rx="1.38187"
                      transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 31.1172 2.9541)"
                      fill="#587C91"
                      stroke="#587C91"
                      stroke-width="0.5"
                    />
                  </svg>
                </div>
                <div v-else>
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="flex mx-auto"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.27675 12.8215C3.27675 7.59555 7.4415 3.34459 12.5614 3.34459C17.6813 3.34459 21.8445 7.59555 21.8445 12.8215C21.8445 18.0474 17.6813 22.2984 12.5614 22.2984C7.4415 22.2984 3.27675 18.0474 3.27675 12.8215ZM29.5579 27.2467L22.7456 20.2949C24.2349 18.1879 25.1212 15.6109 25.1212 12.8215C25.1212 5.75101 19.4868 0 12.5614 0C5.63437 0 0 5.75101 0 12.8215C0 19.8919 5.63437 25.6429 12.5614 25.6429C15.5728 25.6429 18.3416 24.5526 20.5075 22.7398L27.2396 29.613C27.2396 29.613 28.6738 30.3871 29.5579 29.6128C30.4421 28.8386 29.5579 27.2467 29.5579 27.2467Z"
                      fill="#587C91"
                    />
                    <mask
                      id="mask0"
                      style="mask-type: alpha"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="30"
                      height="30"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3.27675 12.8215C3.27675 7.59555 7.4415 3.34459 12.5614 3.34459C17.6813 3.34459 21.8445 7.59555 21.8445 12.8215C21.8445 18.0474 17.6813 22.2984 12.5614 22.2984C7.4415 22.2984 3.27675 18.0474 3.27675 12.8215ZM29.5579 27.2467L22.7456 20.2949C24.2349 18.1879 25.1212 15.6109 25.1212 12.8215C25.1212 5.75101 19.4868 0 12.5614 0C5.63437 0 0 5.75101 0 12.8215C0 19.8919 5.63437 25.6429 12.5614 25.6429C15.5728 25.6429 18.3416 24.5526 20.5075 22.7398L27.2396 29.613C27.2396 29.613 28.6738 30.3871 29.5579 29.6128C30.4421 28.8386 29.5579 27.2467 29.5579 27.2467Z"
                        fill="white"
                      />
                    </mask>
                    <g mask="url(#mask0)"></g>
                  </svg>
                </div>

                Search
              </a>
              <!-- Profile dropdown -->
              <div class="account-link">
                <div class="mx-2 sm:mx-6">
                  <a
                    @click="toggleMyAccount"
                    class="menu-secondary-link whitespace-nowrap cursor-pointer"
                    id="user-menu"
                    aria-label="User menu"
                    aria-haspopup="true"
                  >
                    <svg
                      width="30"
                      height="32"
                      viewBox="0 0 30 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="flex mx-auto"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M23 7.5C23 3.40909 19.5909 0 15.5 0C11.4091 0 8 3.40909 8 7.5C8 11.5909 11.4091 15 15.5 15C19.5909 15 23 11.5909 23 7.5ZM11.1818 7.27273C11.1818 5 13 2.95455 15.5001 2.95455C17.7728 2.95455 19.8183 4.77273 19.8183 7.27273C19.8183 9.54545 18.0001 11.5909 15.5001 11.5909C13.2273 11.5909 11.1818 9.77273 11.1818 7.27273Z"
                        fill="#587C91"
                      />
                      <path
                        d="M30 29.931C30 32.4839 27 32.7159 27 30.3951C26.7692 23.8969 21.4615 19.0233 15 19.0233C8.53846 19.0233 3.23077 23.8969 3 30.3951C3 32.7159 0 32.4839 0 29.931C0.461538 22.0403 7.15385 15.7742 15 16.0062C22.8462 16.0062 29.5385 22.0403 30 29.931Z"
                        fill="#587C91"
                      />
                    </svg>

                    My Account
                  </a>
                </div>
                <transition
                  enter-active-class="transition ease-out duration-100"
                  enter-class="transform opacity-0 scale-95"
                  enter-to-class="transform opacity-100 scale-100"
                  leave-active-class="transition ease-in duration-75"
                  leave-class="transform opacity-100 scale-100"
                  leave-to-class="transform opacity-0 scale-95"
                >
                  <div
                    v-show="isOpen"
                    class="absolute mt-2 z-20 w-full bg-white menu-my-account"
                  >
                    <div
                      class="py-1"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="user-menu"
                    >
                      <div class="container mx-auto pb-16">
                        <MyAccount @hideMyAccount="hideMenu()" />
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
              <div @click="hideMenu()">
                <NuxtLink
                  to="/cart/"
                  class="menu-secondary-link relative cart-link"
                >
                  <svg
                    width="34"
                    height="32"
                    viewBox="0 0 34 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M30.8494 9.41847L28.3226 19.7487C28.1882 20.2518 27.7502 20.5872 27.2449 20.5872H13.8022C13.2969 20.5872 12.8592 20.2518 12.7241 19.7487L9.7931 8.04334H29.7716C30.1085 8.04334 30.4454 8.21104 30.6472 8.47936C30.8494 8.74768 30.9508 9.08308 30.8494 9.41847ZM29.7716 5.93034H9.25406L8.61395 3.4484C8.24336 2.00619 6.96348 1 5.48078 1H2.04439C1.47166 1 1 1.46956 1 2.03973C1 2.60991 1.47166 3.07946 2.04439 3.07946H5.48078C5.98613 3.07946 6.4241 3.41486 6.55886 3.91796L10.6694 20.2183C11.0396 21.6605 12.3199 22.6667 13.8022 22.6667H27.2449C28.7269 22.6667 30.0412 21.6605 30.3781 20.2183L32.9048 9.88803C33.1406 8.94892 32.9382 7.94272 32.2984 7.17131C31.6916 6.3999 30.7483 5.93034 29.7716 5.93034Z"
                      fill="#587C91"
                    />
                    <path
                      d="M28.3226 19.7487L28.8058 19.8778L28.8083 19.8675L28.3226 19.7487ZM12.7241 19.7487L12.239 19.8702L12.2412 19.8784L12.7241 19.7487ZM9.7931 8.04334V7.54334H9.15247L9.30808 8.16479L9.7931 8.04334ZM30.6472 8.47936L30.2476 8.7799L30.2479 8.78022L30.6472 8.47936ZM9.25406 5.93034L8.76991 6.05521L8.86665 6.43034H9.25406V5.93034ZM8.61395 3.4484L8.12968 3.57284L8.12979 3.57327L8.61395 3.4484ZM6.55886 3.91796L7.04373 3.79568L7.04183 3.78859L6.55886 3.91796ZM10.6694 20.2183L10.1846 20.3405L10.1851 20.3426L10.6694 20.2183ZM30.3781 20.2183L29.8924 20.0995L29.8912 20.1045L30.3781 20.2183ZM32.9048 9.88803L32.4199 9.76625L32.4191 9.76923L32.9048 9.88803ZM32.2984 7.17131L31.9053 7.48053L31.9135 7.4905L32.2984 7.17131ZM30.3637 9.29968L27.8369 19.6299L28.8083 19.8675L31.3351 9.53727L30.3637 9.29968ZM27.8396 19.6196C27.7627 19.9073 27.5203 20.0872 27.2449 20.0872V21.0872C27.9801 21.0872 28.6137 20.5963 28.8057 19.8778L27.8396 19.6196ZM27.2449 20.0872H13.8022V21.0872H27.2449V20.0872ZM13.8022 20.0872C13.5271 20.0872 13.2845 19.9075 13.207 19.619L12.2412 19.8784C12.434 20.5961 13.0667 21.0872 13.8022 21.0872V20.0872ZM13.2092 19.6273L10.2781 7.92189L9.30808 8.16479L12.2391 19.8702L13.2092 19.6273ZM9.7931 8.54334H29.7716V7.54334H9.7931V8.54334ZM29.7716 8.54334C29.9521 8.54334 30.1407 8.63776 30.2476 8.7799L31.0468 8.17882C30.7501 7.78432 30.2649 7.54334 29.7716 7.54334V8.54334ZM30.2479 8.78022C30.3815 8.95761 30.4142 9.13001 30.3708 9.27377L31.328 9.56318C31.4873 9.03614 31.3172 8.53775 31.0466 8.1785L30.2479 8.78022ZM29.7716 5.43034H9.25406V6.43034H29.7716V5.43034ZM9.73822 5.80547L9.09811 3.32353L8.12979 3.57327L8.76991 6.05521L9.73822 5.80547ZM9.09822 3.32396C8.67179 1.66443 7.1955 0.5 5.48078 0.5V1.5C6.73145 1.5 7.81494 2.34795 8.12968 3.57284L9.09822 3.32396ZM5.48078 0.5H2.04439V1.5H5.48078V0.5ZM2.04439 0.5C1.19763 0.5 0.5 1.19131 0.5 2.03973H1.5C1.5 1.7478 1.74569 1.5 2.04439 1.5V0.5ZM0.5 2.03973C0.5 2.88816 1.19763 3.57946 2.04439 3.57946V2.57946C1.74569 2.57946 1.5 2.33166 1.5 2.03973H0.5ZM2.04439 3.57946H5.48078V2.57946H2.04439V3.57946ZM5.48078 3.57946C5.75617 3.57946 5.99874 3.75931 6.07588 4.04733L7.04183 3.78859C6.84946 3.07041 6.21608 2.57946 5.48078 2.57946V3.57946ZM6.07404 4.04022L10.1846 20.3405L11.1542 20.096L7.04368 3.7957L6.07404 4.04022ZM10.1851 20.3426C10.6112 22.0023 12.0879 23.1667 13.8022 23.1667V22.1667C12.5518 22.1667 11.4681 21.3187 11.1537 20.0939L10.1851 20.3426ZM13.8022 23.1667H27.2449V22.1667H13.8022V23.1667ZM27.2449 23.1667C28.9505 23.1667 30.4732 22.0089 30.865 20.332L29.8912 20.1045C29.6091 21.3121 28.5034 22.1667 27.2449 22.1667V23.1667ZM30.8637 20.3371L33.3905 10.0068L32.4191 9.76923L29.8924 20.0995L30.8637 20.3371ZM33.3898 10.0098C33.6627 8.92291 33.4291 7.75144 32.6833 6.85212L31.9135 7.4905C32.4472 8.13401 32.6186 8.97493 32.4199 9.76625L33.3898 10.0098ZM32.6914 6.8622C31.9925 5.97367 30.9059 5.43034 29.7716 5.43034V6.43034C30.5907 6.43034 31.3907 6.82612 31.9054 7.48042L32.6914 6.8622Z"
                      fill="#587C91"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14.4739 28.9804C13.729 28.9804 13.146 28.4032 13.146 27.666C13.146 26.9292 13.729 26.3522 14.4739 26.3522C15.2188 26.3522 15.8018 26.9292 15.8018 27.666C15.8018 28.3715 15.1864 28.9804 14.4739 28.9804ZM14.4739 24.333C12.6277 24.333 11.1055 25.8391 11.1055 27.666C11.1055 29.4933 12.6277 30.9997 14.4739 30.9997C16.32 30.9997 17.8423 29.4933 17.8423 27.666C17.8423 25.8391 16.32 24.333 14.4739 24.333Z"
                      fill="#587C91"
                    />
                    <path
                      d="M14.4739 28.7304C13.8646 28.7304 13.396 28.2627 13.396 27.666H12.896C12.896 28.5437 13.5933 29.2304 14.4739 29.2304V28.7304ZM13.396 27.666C13.396 27.0697 13.8645 26.6022 14.4739 26.6022V26.1022C13.5934 26.1022 12.896 26.7886 12.896 27.666H13.396ZM14.4739 26.6022C15.0833 26.6022 15.5518 27.0697 15.5518 27.666H16.0518C16.0518 26.7886 15.3544 26.1022 14.4739 26.1022V26.6022ZM15.5518 27.666C15.5518 28.231 15.0508 28.7304 14.4739 28.7304V29.2304C15.3221 29.2304 16.0518 28.512 16.0518 27.666H15.5518ZM14.4739 24.083C12.4922 24.083 10.8555 25.6985 10.8555 27.666H11.3555C11.3555 25.9797 12.7633 24.583 14.4739 24.583V24.083ZM10.8555 27.666C10.8555 29.6338 12.4921 31.2497 14.4739 31.2497V30.7497C12.7633 30.7497 11.3555 29.3527 11.3555 27.666H10.8555ZM14.4739 31.2497C16.4557 31.2497 18.0923 29.6338 18.0923 27.666H17.5923C17.5923 29.3527 16.1844 30.7497 14.4739 30.7497V31.2497ZM18.0923 27.666C18.0923 25.6985 16.4556 24.083 14.4739 24.083V24.583C16.1845 24.583 17.5923 25.9797 17.5923 27.666H18.0923Z"
                      fill="#587C91"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M26.263 28.9804C25.518 28.9804 24.935 28.4032 24.935 27.666C24.935 26.9292 25.518 26.3522 26.263 26.3522C27.0079 26.3522 27.5909 26.9292 27.5909 27.666C27.5909 28.3715 26.9755 28.9804 26.263 28.9804ZM26.263 24.333C24.4168 24.333 22.8945 25.8391 22.8945 27.666C22.8945 29.4933 24.4168 30.9997 26.263 30.9997C28.1091 30.9997 29.6314 29.4933 29.6314 27.666C29.599 25.8391 28.1091 24.333 26.263 24.333Z"
                      fill="#587C91"
                    />
                    <path
                      d="M29.6314 27.666H29.8814L29.8813 27.6616L29.6314 27.666ZM26.263 28.7304C25.6537 28.7304 25.185 28.2627 25.185 27.666H24.685C24.685 28.5437 25.3823 29.2304 26.263 29.2304V28.7304ZM25.185 27.666C25.185 27.0697 25.6536 26.6022 26.263 26.6022V26.1022C25.3825 26.1022 24.685 26.7886 24.685 27.666H25.185ZM26.263 26.6022C26.8723 26.6022 27.3409 27.0697 27.3409 27.666H27.8409C27.8409 26.7886 27.1434 26.1022 26.263 26.1022V26.6022ZM27.3409 27.666C27.3409 28.231 26.8399 28.7304 26.263 28.7304V29.2304C27.1111 29.2304 27.8409 28.512 27.8409 27.666H27.3409ZM26.263 24.083C24.2812 24.083 22.6445 25.6985 22.6445 27.666H23.1445C23.1445 25.9797 24.5524 24.583 26.263 24.583V24.083ZM22.6445 27.666C22.6445 29.6338 24.2812 31.2497 26.263 31.2497V30.7497C24.5524 30.7497 23.1445 29.3527 23.1445 27.666H22.6445ZM26.263 31.2497C28.2447 31.2497 29.8814 29.6338 29.8814 27.666H29.3814C29.3814 29.3527 27.9735 30.7497 26.263 30.7497V31.2497ZM29.8813 27.6616C29.8466 25.7016 28.2487 24.083 26.263 24.083V24.583C27.9696 24.583 29.3514 25.9766 29.3814 27.6705L29.8813 27.6616Z"
                      fill="#587C91"
                    />
                  </svg>

                  Cart <span>{{ cartServicesCount || "" }}</span>
                </NuxtLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="[isOpenMobile ? '' : 'hidden', 'lg:hidden']"
        id="mobile_menu"
      >
        <div class="icon-items-container">
          <a href="#" @click="toggleMobileSearch" class="menu-secondary-link">
            <div v-if="openMobileSearch">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="flex mx-auto"
              >
                <rect
                  x="0.5"
                  y="2.9541"
                  width="2.76375"
                  height="40.535"
                  rx="1.38187"
                  transform="rotate(-45 0.5 2.9541)"
                  fill="#587C91"
                  stroke="#587C91"
                  stroke-width="0.5"
                />
                <rect
                  width="2.76375"
                  height="40.535"
                  rx="1.38187"
                  transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 31.1172 2.9541)"
                  fill="#587C91"
                  stroke="#587C91"
                  stroke-width="0.5"
                />
              </svg>
            </div>
            <div v-else>
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="flex mx-auto"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.27675 12.8215C3.27675 7.59555 7.4415 3.34459 12.5614 3.34459C17.6813 3.34459 21.8445 7.59555 21.8445 12.8215C21.8445 18.0474 17.6813 22.2984 12.5614 22.2984C7.4415 22.2984 3.27675 18.0474 3.27675 12.8215ZM29.5579 27.2467L22.7456 20.2949C24.2349 18.1879 25.1212 15.6109 25.1212 12.8215C25.1212 5.75101 19.4868 0 12.5614 0C5.63437 0 0 5.75101 0 12.8215C0 19.8919 5.63437 25.6429 12.5614 25.6429C15.5728 25.6429 18.3416 24.5526 20.5075 22.7398L27.2396 29.613C27.2396 29.613 28.6738 30.3871 29.5579 29.6128C30.4421 28.8386 29.5579 27.2467 29.5579 27.2467Z"
                  fill="#587C91"
                />
                <mask
                  id="mask0"
                  style="mask-type: alpha"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="30"
                  height="30"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.27675 12.8215C3.27675 7.59555 7.4415 3.34459 12.5614 3.34459C17.6813 3.34459 21.8445 7.59555 21.8445 12.8215C21.8445 18.0474 17.6813 22.2984 12.5614 22.2984C7.4415 22.2984 3.27675 18.0474 3.27675 12.8215ZM29.5579 27.2467L22.7456 20.2949C24.2349 18.1879 25.1212 15.6109 25.1212 12.8215C25.1212 5.75101 19.4868 0 12.5614 0C5.63437 0 0 5.75101 0 12.8215C0 19.8919 5.63437 25.6429 12.5614 25.6429C15.5728 25.6429 18.3416 24.5526 20.5075 22.7398L27.2396 29.613C27.2396 29.613 28.6738 30.3871 29.5579 29.6128C30.4421 28.8386 29.5579 27.2467 29.5579 27.2467Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask0)"></g>
              </svg>
            </div>

            <span>Search</span>
          </a>
          <!-- Profile dropdown -->
          <div class="">
            <div class="">
              <span
                @click="toggleMobileMyAccount"
                class="menu-secondary-link whitespace-nowrap"
                id="user-menu"
                aria-label="User menu"
                aria-haspopup="true"
              >
                <svg
                  width="30"
                  height="32"
                  viewBox="0 0 30 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="flex mx-auto"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M23 7.5C23 3.40909 19.5909 0 15.5 0C11.4091 0 8 3.40909 8 7.5C8 11.5909 11.4091 15 15.5 15C19.5909 15 23 11.5909 23 7.5ZM11.1818 7.27273C11.1818 5 13 2.95455 15.5001 2.95455C17.7728 2.95455 19.8183 4.77273 19.8183 7.27273C19.8183 9.54545 18.0001 11.5909 15.5001 11.5909C13.2273 11.5909 11.1818 9.77273 11.1818 7.27273Z"
                    fill="#587C91"
                  />
                  <path
                    d="M30 29.931C30 32.4839 27 32.7159 27 30.3951C26.7692 23.8969 21.4615 19.0233 15 19.0233C8.53846 19.0233 3.23077 23.8969 3 30.3951C3 32.7159 0 32.4839 0 29.931C0.461538 22.0403 7.15385 15.7742 15 16.0062C22.8462 16.0062 29.5385 22.0403 30 29.931Z"
                    fill="#587C91"
                  />
                </svg>

                <span>My Account</span>
              </span>
            </div>
            <Transition
              enter-active-class="transition ease-out duration-100"
              enter-class="transform opacity-0 scale-95"
              enter-to-class="transform opacity-100 scale-100"
              leave-active-class="transition ease-in duration-75"
              leave-class="transform opacity-100 scale-100"
              leave-to-class="transform opacity-0 scale-95"
            >
              <div
                v-show="isMobileAccountOpen"
                class="absolute mt-2 z-20 w-full bg-white mobile-menu-my-account max-h-96 overflow-y-scroll"
              >
                <div
                  class="py-1"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="user-menu"
                >
                  <div class="container mx-auto pb-16">
                    <MyAccount @hideMyAccount="hideMenu()" />
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
        <div
          v-show="openMobileSearch"
          id="mobile-search-bar"
          class="rounded-b-3xl absolute z-50 bg-white w-full drop-shadow-lg"
        >
          <div class="container mx-auto">
            <form id="search" @submit.prevent="searchSubmit">
              <input
                id="search_field"
                class="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 mt-4 py-2 px-2 leading-tight focus:outline-none rounded-3xl"
                type="text"
                placeholder="What can we help you find?"
                aria-label="search"
                v-model="search"
              />
              <button
                class="flex-shrink-0 bg-green-600 border-green-600 text-sm border-4 text-white py-1 px-2 lg:px-16 rounded-full"
                type="submit"
                id="search_submit"
              >
                Search
              </button>
            </form>
            <div v-if="errors.length" class="red">
              <b>Please correct the following error(s):</b>
              <ul>
                <li class="red" v-for="(error, index) in errors" :key="index">
                  {{ error }}
                </li>
              </ul>
            </div>
            <ul id="searchResults" class="list-none" v-if="searchResults">
              <li
                v-for="(results, type) in searchResults"
                :key="type"
                v-show="results.length > 0"
              >
                <ul class="list-none">
                  {{
                    getSearchResultTypeText(type)
                  }}
                  <li
                    v-for="result in results"
                    :key="result.id"
                    @click="hideMenu()"
                  >
                    <NuxtLink :to="getSearchResultLink(type, result)">
                      {{ title(result) }}
                    </NuxtLink>
                  </li>
                </ul>
              </li>
            </ul>
            <p v-else>No results found.</p>
          </div>
        </div>
        <nav class="mobile max-h-96 overflow-y-scroll">
          <ul class="">
            <li
              v-for="menu in menus"
              :key="menu.id"
              class="mobile-menu-header-item"
              :class="{
                'menu.slug': true,
                expanded: expandedMobileItem,
              }"
            >
              <div class="flex justify-between">
                <div @click="hideMenu()">
                  <NuxtLink :to="menu.slug" class="">
                    {{ menu.name }}
                  </NuxtLink>
                </div>
                <svg
                  v-if="menu.child_menu_items.length > 0"
                  @click="toggleExpandedMobileItem"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-12 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </div>
              <MobileDropdown
                :menu="menu"
                v-if="menu.primary && menu.primary.length > 0"
                @hideDropdown="hideMenu()"
              />
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div
      v-show="openSearch"
      id="search-bar"
      class="rounded-b-3xl absolute z-50 bg-white w-full drop-shadow-lg"
    >
      <div class="container mx-auto">
        <form id="search" @submit.prevent="searchSubmit">
          <input
            id="search_field"
            class="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 mt-4 py-2 px-2 leading-tight focus:outline-none rounded-3xl"
            type="text"
            placeholder="What can we help you find?"
            aria-label="search"
            v-model="search"
          />
          <button
            class="flex-shrink-0 bg-green-600 border-green-600 text-sm border-4 text-white py-1 px-2 lg:px-16 rounded-full"
            type="submit"
            id="search_submit"
          >
            Search
          </button>
        </form>
        <div v-if="errors.length" class="red">
          <b>Please correct the following error(s):</b>
          <ul>
            <li class="red" v-for="(error, index) in errors" :key="index">
              {{ error }}
            </li>
          </ul>
        </div>
        <ul id="searchResults" class="list-none" v-if="searchResults">
          <li
            v-for="(results, type) in searchResults"
            :key="type"
            v-show="results.length > 0"
          >
            <ul class="list-none">
              {{
                getSearchResultTypeText(type)
              }}
              <li
                v-for="result in results"
                :key="result.id"
                @click="hideMenu()"
              >
                <NuxtLink :to="getSearchResultLink(type, result)">
                  {{ title(result) }}
                </NuxtLink>
              </li>
            </ul>
          </li>
        </ul>
        <p v-else>No results found.</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStore } from "vuex";
import type { Store } from "vuex/types/index.js";
import type State from "~/domains/store/State";
import logo from '~/assets/images/logo_spring_green.webp';

const store: Store<State> = useStore();
const router = useRouter();
const auth = useAuth();

const currentRouteId = computed(() => String(router.currentRoute.value.name ?? ""));

const { $axios, $sg, $services, $customers, $config } = useNuxtApp();

const isOpen = ref(false);
const isOpenMobile = ref(false);
const isMobileAccountOpen = ref(false);
const menus = ref([]);
const openSearch = ref(false);
const openMobileSearch = ref(false);
const search = ref("");
const searchResults = ref(true);
const errors = ref([]);
const expandedMobileItem = ref(false);
const dropdownsHidden = ref(false);

const homeUrl = computed(() => {
  if (store.state.persistedState.franchise_slug) {
    return `/lawn-care-locations/${store.state.persistedState.franchise_slug}/`;
  }
  return "/";
});

const cartServicesCount = computed(() => {
  return $services.getCartServices().length;
});

const isAuthenticated = computed(async () => {
  if (auth.status.value === "authenticated") {
    const persistedState = store.state.persistedState;
    if (!persistedState.scope || !persistedState.scope.cust_No || !persistedState.scope.sqldbid) {
      return false;
    }
    const check = await $customers.getCustomerById(persistedState.scope.cust_No, persistedState.scope.sqldbid);
    if (check.error) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
});

function getSearchResultTypeText(type: string) {
  const map: Record<string, string> = {
    services: "Services",
    franchise: "Franchises",
    lawnCareGuides: "Lawn Care Guides",
    pestControlGuides: "Pest Control Guides",
    treeCareGuides: "Tree Care Guides",
    posts: "Posts",
  };

  return map[type] ?? "Other";
}

function getSearchResultLink(type: string, result: any) {
  const map: Record<string, string> = {
    services: "/services/",
    franchise: "/lawn-care-locations/",
    lawnCareGuides: "/learn/lawn-care-guides/",
    pestControlGuides: "/learn/pest-control-guides/",
    treeCareGuides: "/learn/tree-care-guides/",
    posts: "/learn/blogs/",
  };

  return map[type] ? `${map[type]}${result.slug}/` : null;
}

function title(data: any) {
  if (typeof data.title !== "undefined") {
    return data.title;
  } else if (typeof data.name !== "undefined") {
    return data.name;
  } else {
    return data.description;
  }
}

function toggle() {
  isOpen.value = !isOpen.value;
}

function toggleMyAccount() {
  isAuthenticated.value.then((valid) => {
    if (valid) {
      router.push("/portal/services");
    } else {
      isOpen.value = !isOpen.value;
    }
  });
}

function toggleMobileMyAccount() {
  isAuthenticated.value.then((valid) => {
    if (valid) {
      router.push("/portal/services");
    } else {
      isMobileAccountOpen.value = !isMobileAccountOpen.value;
    }
  });
}

function toggleMobile() {
  isOpenMobile.value = !isOpenMobile.value;
}

function toggleSearch() {
  openSearch.value = !openSearch.value;
}

function toggleMobileSearch() {
  openMobileSearch.value = !openMobileSearch.value;
}

function toggleExpandedMobileItem(e: Event) {
  e.preventDefault();
  const target = e.target as HTMLElement;
  target.closest(".mobile-menu-header-item")?.classList.toggle("expanded");
}

async function searchSubmit() {
  errors.value = [];
  if (!search.value) {
    errors.value.push("Search Field Required");
    return;
  }

  store.commit("SET_SHOW_LOADER", true);

  try {
    const response = await $axios.post(
      `${$config.public.sgCmsApi}search`,
      {
        search: search.value,
      }
    );
    const responseData = response.data;

    if (
      responseData.franchise.length > 0 ||
      responseData.lawnCareGuides.length > 0 ||
      responseData.pestControlGuides.length > 0 ||
      responseData.treeCareGuides.length > 0 ||
      responseData.services.length > 0 ||
      responseData.posts.length > 0
    ) {
      searchResults.value = responseData;
    } else {
      searchResults.value = false;
    }
  } catch (err) {
    console.error(err);
    searchResults.value = false;
  } finally {
    store.commit("SET_SHOW_LOADER", false);
  }
}

function hideMenu() {
  isOpen.value = false;
  isOpenMobile.value = false;
  isMobileAccountOpen.value = false;
  openSearch.value = false;
  openMobileSearch.value = false;
  expandedMobileItem.value = false;
  dropdownsHidden.value = true;
}

watch(
  () => router.currentRoute.value.fullPath,
  (newFullPath, oldFullPath) => {
    if (newFullPath !== oldFullPath) {
      hideMenu();
    }
  }
);

onMounted(async () => {
//   this.$root.$on("showLogin", () => {
//     isOpen.value = true;
//   });

  const menuData = await $sg.getOctoberData("menu");
  menuData.sort(
    (a: any, b: any) => a.order - b.order || a.name.localeCompare(b.name)
  );
  menuData.forEach((menu: any) => {
    menu["primary"] = [];
    menu["secondary"] = [];
    menu.child_menu_items.sort(
      (a: any, b: any) => a.order - b.order || a.name.localeCompare(b.name)
    );
    menu.child_menu_items.forEach((value: any) => {
      menu[value.type].push(value);
    });
  });
  menus.value = menuData;

  // Add class when mobile becomes sticky
  const el = document.querySelector(".header");
  const observer = new IntersectionObserver(
    ([e]) => e.target.classList.toggle("is-sticky", e.intersectionRatio < 1),
    { threshold: [1] }
  );

  if (el) observer.observe(el);
});
</script>

<style scoped>
.bg-green-600 {
  background-color: #00810e;
}

.border-green-600 {
  border-color: #00810e;
}

.header {
  border-bottom: 1px solid #b9b9b9;
  z-index: 200;
  position: relative;
}

/* Mobile Sticky styles*/
@media screen and (max-width: 1023px) {
  .header {
    position: sticky;
    top: -1px;
    transition: all 0.2s ease-in-out;
  }

  .header.is-sticky .sticky-padding-small {
    padding: 0.25em 3%;
  }

  .header .sticky-padding-small {
    transition: all 0.2s ease-in-out;
  }
}

.headerSearch {
  cursor: pointer;
}

#search-bar {
  border-bottom-left-radius: 26px;
  border-bottom-right-radius: 26px;
  padding: 20px 0 0;
  box-shadow: 0px 14px 14px rgba(0, 0, 0, 0.25);
}

#mobile-search-bar {
  padding: 20px 0 0;
  box-shadow: 0px 14px 14px rgba(0, 0, 0, 0.25);
}

#search {
  position: relative;
  margin: 0 auto;
}

#search_field {
  border-radius: 100px;
  background-image: url("~/assets/images/searchBox.png");
  background-position: 10px center;
  background-repeat: no-repeat;
  text-indent: 25px;
  width: 100%;
  border: none;
  background-color: #f6f8f9;
}

#search_submit {
  position: absolute;
  right: 5px;
  top: 10px;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #517185;
  opacity: 0.9; /* Firefox */
}

.menu-secondary-link {
  color: #517185;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  display: inline-block;
}

.menu-secondary-link img,
.menu-secondary-link svg {
  margin-bottom: 5px !important;
}

.menu ul {
  margin: 0;
  padding: 0;
}

.menu li {
  list-style: none;
  margin: 20px 0 0;
  padding: 20px 0 36.5px;
}

.menu a {
  font-weight: 600;
  color: #517185;
}

.mobile ul {
  padding: 0;
  margin: 0 0 0 40px;
}

#mobile_menu {
  background: #fff;
  width: 100%;
}

.icon-items-container {
  display: flex;
  justify-content: space-around;
  padding: 15px;
  border-top: 1px solid #eef1f4;
  border-bottom: 1px solid #eef1f4;
}

.icon-items-container a.menu-secondary-link {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.icon-items-container a.menu-secondary-link span {
  line-height: 1;
}

.mobile li {
  list-style: none;
  margin: 0;
  width: 95%;
  border-bottom: 2px solid #eef1f4;
}

.has-children {
  background: url(~/assets/images/arrow-green.png) no-repeat 98% center;
}

.mobile a {
  font-weight: 600;
  display: flex;
  justify-content: space-between;
}

.mobile .mobile-menu-header-item > a {
  padding: 15px 0;
}

.mobile .mobile-menu-header-item svg {
  transition: transform 0.2s ease-in-out;
}

.mobile .mobile-menu-header-item.expanded svg {
  transform: rotate(180deg);
}

.menu .services-pest-services-:hover,
.menu .services-lawn-care-services-:hover,
.menu .services-tree-and-shrub-services-:hover {
  background: url(~/assets/images/menu_arrow.png) no-repeat center bottom;
  background-size: auto 20px;
}

.menu.dropdowns-hidden :deep(.dropdown) {
  display: none !important;
}

.menu-my-account {
  left: 0;
  text-align: center;
  padding: 30px 0;
  border-bottom-left-radius: 26px;
  border-bottom-right-radius: 26px;
  box-shadow: 0px 14px 14px rgba(0, 0, 0, 0.25);
}
.mobile-menu-my-account {
  left: 0;
  text-align: center;
  padding: 0 0;
  border-bottom-left-radius: 26px;
  border-bottom-right-radius: 26px;
  box-shadow: 0px 14px 14px rgba(0, 0, 0, 0.25);
}

.cart-link span {
  position: absolute;
  right: -10px;
  top: -10px;
  font-size: 12px;
  font-weight: 600;
  background: #ce4200;
  color: #fff;
  line-height: 20px;
  width: 20px;
  border-radius: 13px;
}

.logo {
  width: 260px;
  aspect-ratio: 762 / 183;
}

@media (max-width: 1180px) {
  .logo {
    width: 180px;
    aspect-ratio: 762 / 183;
  }
}

@media (max-width: 1120px) AND (min-width: 1024px) {
  .menu a {
    font-size: 13px;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}

@media (max-width: 1180px) {
  .menu-secondary-link {
    font-size: 11px;
    font-weight: normal;
  }

  .menu-secondary-link img,
  .menu-secondary-link svg {
    width: 15px;
    height: 15px;
  }
}

@media (max-width: 640px) {
  .logo {
    width: 120px;
  }
}

@media (max-width: 1024px) {
  .search-link,
  .account-link {
    display: none;
  }
}
</style>
